import { useState } from "react";

import useDialog from "@datanac/datanac-mui-toolkit/dist/hooks/useDialog";
import { Add } from "@mui/icons-material";
import { Box, Dialog, IconButton } from "@mui/material";
import { FinancialIcon } from "components/Icons/Icons";
import { ButtonLargeSquare } from "mui-toolkit/ButtonLargeSquare";
import { formatPrice } from "utility/formatters";
import { v4 } from "uuid";

import { TilleyCard } from "../../Cards/TilleyCard";
import { DeleteIcon } from "../../Icons/Icons";
import { FinancialStatementSchedule_Accounts_Edit } from "./FinancialStatementSchedule_Accounts_EditDialog";
import { schedule_financial_statement_accounts_receivable } from "./useFinancialStatementSchedule";

export const SYSTEM_PROMPT_ACCOUNT_PARSER_TERMS = "form_financialinterview_term";

export const FinancialStatementSchedule_Accounts_Receivable_View = ({ year, accounts, onChange, is_lender }) => {
  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();

  const CATEGORY = schedule_financial_statement_accounts_receivable;

  const [editingItem, setEditingItem] = useState(null);

  const handleChange = async (account) => {
    if (!account.id) {
      account.id = v4();
    }
    if (!account.year && year) {
      account.year = year;
    }
    if (!account.category) {
      account.category = CATEGORY;
    }

    onChange && onChange(account);
  };

  const handleDeleteOnClick = (account) => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this entry?",
      promptDetail: null,
      callback: () => {
        const _newState = { ...account };
        _newState.is_active = false;
        handleChange(_newState);

        return false;
      },
    });
  };

  // ---

  return (
    <>
      <Box className="cardContainer">
        {(accounts || [])
          ?.filter((item) => item.is_active != false)
          ?.map((item, index) => (
            <TilleyCard
              key={index}
              Avatar={FinancialIcon}
              onClick={() => setEditingItem(item)}
              subtitle={item?.account_name || item?.name}
              title={(item.financial_institution_name || "Receivables") + " - " + item?.account_type}
              details={[
                {
                  value: formatPrice(item?.value, 0),
                  label: "Value",
                },
                {
                  value: formatPrice(item?.adjusted_value, 0),
                  label: "Adjusted Value",
                },
              ]}
              action={
                <>
                  <IconButton
                    onClick={(e) => {
                      handleDeleteOnClick(item);
                      e.stopPropagation();
                      return false;
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              }
            />
          ))}

        <ButtonLargeSquare icon={<Add />} title={"Add New"} onClick={() => setEditingItem({})} />
      </Box>

      <Dialog open={Boolean(editingItem != null)}>
        <FinancialStatementSchedule_Accounts_Edit
          onChange={handleChange}
          onClose={() => setEditingItem(null)}
          account={editingItem}
          is_lender={is_lender}
        />
      </Dialog>

      {confirmDialogComponent}
    </>
  );
};
